export default class Schema {

  constructor(selector) {
    this.togglers = document.querySelectorAll(selector);
  }

  getTogglers() {

    const slideSelector = '.image__slide';
    const openClass = 'ic-open';

    this.togglers.forEach((element) => { // Get the target for each toggler
      let target = document.getElementById(element.getAttribute('data-target'));

      // This is not optimal, we can't close the slide without opening it first.It would be better to attach the event listener on open. But for such a small number of slides the performance is not important
      if (target == null)
        return;


      let closeButton = target.querySelector('[data-close]');
      closeButton.addEventListener('click', (event) => {
        target.classList.remove(openClass);
      });

      element.addEventListener('click', (event) => {
        target.classList.add(openClass);

        // We have to close the other ones
        let openSlides = document.querySelectorAll(slideSelector + '.' + openClass)

        openSlides.forEach((element) => {
          if (element !== target)
            element.classList.remove(openClass)
        })
      });

      window.addEventListener('mouseup', (event) => {
        if (event.target != target && event.target.parentNode != target) {
          target.classList.remove(openClass);
        }
      })
    });
  }

}
